import { render, staticRenderFns } from "./CustomerStatementTable.vue?vue&type=template&id=719e0710"
import script from "./CustomerStatementTable.vue?vue&type=script&lang=js"
export * from "./CustomerStatementTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports